import { Banner } from '../components/Banner';
import { AskAnything } from '../components/AskAnything';
import { TabGrid } from '../components/TabGrid';
import { Footer } from '../components/Footer';

/**
 * The home SPA. Three fixed vertical bands per PRD §5:
 *   • upper ~45 % of viewport — Banner
 *   • middle ~10 % — AskAnything search
 *   • lower ~45 % — TabGrid
 *
 * Fits within one 1440×900 desktop viewport; below 900 px tall, or on
 * mobile, the layout stacks and the page becomes scrollable.
 *
 * Tailwind flex-column with h-screen (min-h on smaller viewports) and
 * flex-basis proportional to each band's height allocation.
 */
export function HomePage(): JSX.Element {
  // Layout note (revised): the earlier version constrained the whole
  // page to `md:h-screen` (100 vh). On viewports shorter than the
  // sum of the sections' min-heights (banner 45vh + middle 10vh +
  // tabs 45vh + footer = > 100vh), flex compressed the grid into the
  // banner and produced a visible overlap. Removed the cap; each
  // section carries a reasonable min-height on its own and the page
  // scrolls naturally when the viewport is short.
  return (
    <div className="flex min-h-screen flex-col">
      <Banner />
      <AskAnything />
      <TabGrid />
      <Footer />
    </div>
  );
}
